import facebook from '../../assets/icons/facebook.png'
import youtube from '../../assets/icons/youtube.png'
import instagram from '../../assets/icons/instagram.png'
import whatsapp from '../../assets/icons/whatsapp.png'

import './footer.css'
import { useState } from 'react'
import { getFormatHora, getFormatFechaLong } from '../../helpers/dates'

const Footer = () => {

    const [hora, setHora] = useState(Date.now());

    setInterval(() => {
        setHora(Date.now())
    }, 30000);


  return (
    <div className='footer-container'>
        <section className='footer-icons'>
            <img src={facebook} alt="Logo Poptelera" />
            <img src={instagram} alt="Logo Poptelera" />
            <img src={youtube} alt="Logo Poptelera" />
            <img src={whatsapp} alt="Logo Poptelera" />
        </section>
        <section className='footer-text'>
                <h2>ByJIM©2023</h2>
                <h4>José Ignacio Martínez</h4>
        </section>
        <section className='footer-date'>
                <h3>{getFormatHora(hora)}</h3>
                <h3>{getFormatFechaLong(hora)}</h3>
        </section>
    </div>
  )
}
export default Footer